/**
 * Автоматично згенеровані маршрути (PRODUCTION MODE)
 * НЕ РЕДАГУЙТЕ ЦЕЙ ФАЙЛ ВРУЧНУ!
 * Генерується плагіном ViteKernelLoaderPlugin під час збірки
 */

import type { IRouteInfo } from '@/Core/Contracts/Loaders/IVitePluginGenerators'

import Component0 from '../src/Containers/AssignmentSection/AssignmentContainer/Pages/AssignmentsWithRequestsPage'
import Component1 from '../src/Containers/AssignmentSection/AssignmentContainer/Pages/AssignmentsWithoutRequestsPage'
import Component2 from '../src/Containers/DriverSection/DriverDashboardContainer/Pages/ChangePasswordPage'
import Component3 from '../src/Containers/DriverSection/DriverDashboardContainer/Pages/DashboardPage'
import Component4 from '../src/Containers/DriverSection/DriverDashboardContainer/Pages/NotificationsPage'
import Component5 from '../src/Containers/DriverSection/DriverDashboardContainer/Pages/ProfilePage'
import Component6 from '../src/Containers/IndexSection/IndexContainer/Pages/IndexPage'
import Component7 from '../src/Containers/PublicSection/AuthContainer/Pages/ForgotPasswordPage'
import Component8 from '../src/Containers/PublicSection/AuthContainer/Pages/LoginPage'
import Component9 from '../src/Containers/PublicSection/AuthContainer/Pages/UserInvitationPage'
import Component10 from '../src/Containers/PublicSection/ErrorContainer/Pages/Error404Page'
import Component11 from '../src/Containers/ReportSection/ReportContainer/Pages/CompletionPage'
import Component12 from '../src/Containers/ReportSection/ReportContainer/Pages/DispatcherRatingPage'
import Component13 from '../src/Containers/ReportSection/ReportContainer/Pages/IndexPage'
import Component14 from '../src/Containers/ReportSection/ReportContainer/Pages/MileageControlPage'
import Component15 from '../src/Containers/RequestSection/RequestContainer/Pages/RequestPage'
import Component16 from '../src/Containers/SettingSection/DepartmentContainer/Pages/DepartmentPage'
import Component17 from '../src/Containers/SettingSection/ERPExchangeContainer/Pages/IndexPage'
import Component18 from '../src/Containers/SettingSection/ListContainer/Pages/IndexPage'
import Component19 from '../src/Containers/SettingSection/PortalSettingsContainer/Pages/IndexPage'
import Component20 from '../src/Containers/SettingSection/ProfileContainer/Pages/ProfilePage'
import Component21 from '../src/Containers/SettingSection/SystemEventsContainer/Pages/IndexPage'
import Component22 from '../src/Containers/SettingSection/UserContainer/Pages/UserPage'
import Component23 from '../src/Containers/SettingSection/UserContainer/Pages/UserProfilePage'
import Component24 from '../src/Containers/ShiftSection/ShiftContainer/Pages/ShiftPage'
import Component25 from '../src/Containers/TransportSection/DriverContainer/Pages/DriverPage'
import Component26 from '../src/Containers/TransportSection/VehicleContainer/Pages/VehiclePage'
import Component27 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component28 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component29 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component30 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component31 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component32 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component33 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component34 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component35 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component36 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component37 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component38 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component39 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component40 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component41 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component42 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component43 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component44 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component45 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component46 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component47 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component48 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component49 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component50 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component51 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component52 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component53 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component54 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component55 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component56 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component57 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component58 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component59 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component60 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component61 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component62 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component63 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component64 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component65 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component66 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component67 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component68 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component69 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component70 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component71 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component72 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component73 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component74 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component75 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component76 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component77 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component78 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component79 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component80 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component81 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component82 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component83 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component84 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component85 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component86 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component87 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component88 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component89 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component90 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component91 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component92 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component93 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component94 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component95 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component96 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component97 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component98 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component99 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component100 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component101 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component102 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component103 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component104 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component105 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component106 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component107 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component108 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component109 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component110 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component111 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component112 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component113 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component114 from '../src/Core/Components/Resource/UniversalResourcePage'

export const generatedRoutes: (IRouteInfo & { component: any })[] = [
  {
    path: "/assignments/with-requests",
    componentName: "AssignmentsWithRequestsPage",
    key: "Assignment.AssignmentsWithRequests",
    section: "assignment",
    container: "assignment",
    group: "container",
    template: "default",
    isIndex: false,
    config: {
      "title": "AssignmentsWithRequests",
      "layout": "default"
    },
    component: Component0
  },
  {
    path: "/assignments/without-requests",
    componentName: "AssignmentsWithoutRequestsPage",
    key: "Assignment.AssignmentsWithoutRequests",
    section: "assignment",
    container: "assignment",
    group: "container",
    template: "default",
    isIndex: false,
    config: {
      "title": "AssignmentsWithoutRequests",
      "layout": "default"
    },
    component: Component1
  },
  {
    path: "/driver/change-password",
    componentName: "ChangePasswordPage",
    key: "Driver.ChangePassword",
    section: "driver",
    container: "driver-dashboard",
    group: "container",
    template: "public",
    isIndex: false,
    config: {
      "title": "ChangePassword",
      "layout": "public"
    },
    component: Component2
  },
  {
    path: "/driver",
    componentName: "DashboardPage",
    key: "Driver.Dashboard",
    section: "driver",
    container: "driver-dashboard",
    group: "container",
    template: "driver",
    isIndex: false,
    config: {
      "title": "Dashboard",
      "layout": "driver"
    },
    component: Component3
  },
  {
    path: "/driver/notifications",
    componentName: "NotificationsPage",
    key: "Driver.Notifications",
    section: "driver",
    container: "driver-dashboard",
    group: "container",
    template: "driver",
    isIndex: false,
    config: {
      "title": "Notifications",
      "layout": "driver"
    },
    component: Component4
  },
  {
    path: "/driver/profile",
    componentName: "ProfilePage",
    key: "Driver.Profile",
    section: "driver",
    container: "driver-dashboard",
    group: "container",
    template: "driver",
    isIndex: false,
    config: {
      "title": "Profile",
      "layout": "driver"
    },
    component: Component5
  },
  {
    path: "/",
    componentName: "IndexPage",
    key: "Index.Index",
    section: "index",
    container: "index",
    group: "container",
    template: "default",
    isIndex: true,
    config: {
      "title": "Index",
      "layout": "default"
    },
    component: Component6
  },
  {
    path: "/public/forgot-password",
    componentName: "ForgotPasswordPage",
    key: "Public.ForgotPassword",
    section: "public",
    container: "auth",
    group: "container",
    template: "public",
    isIndex: false,
    config: {
      "title": "ForgotPassword",
      "layout": "public"
    },
    component: Component7
  },
  {
    path: "/public/login",
    componentName: "LoginPage",
    key: "Public.Login",
    section: "public",
    container: "auth",
    group: "container",
    template: "public",
    isIndex: false,
    config: {
      "title": "Login",
      "layout": "public"
    },
    component: Component8
  },
  {
    path: "/user-invitation/:token",
    componentName: "UserInvitationPage",
    key: "Public.UserInvitation",
    section: "public",
    container: "auth",
    group: "container",
    template: "public",
    isIndex: false,
    config: {
      "title": "UserInvitation",
      "layout": "public"
    },
    component: Component9
  },
  {
    path: "/public/error404",
    componentName: "Error404Page",
    key: "Public.Error404",
    section: "public",
    container: "error",
    group: "container",
    template: "public",
    isIndex: false,
    config: {
      "title": "Error404",
      "layout": "public"
    },
    component: Component10
  },
  {
    path: "/reports/completion",
    componentName: "CompletionPage",
    key: "Report.Completion",
    section: "report",
    container: "report",
    group: "container",
    template: "default",
    isIndex: false,
    config: {
      "title": "Completion",
      "layout": "default"
    },
    component: Component11
  },
  {
    path: "/reports/dispatcher-rating",
    componentName: "DispatcherRatingPage",
    key: "Report.DispatcherRating",
    section: "report",
    container: "report",
    group: "container",
    template: "default",
    isIndex: false,
    config: {
      "title": "DispatcherRating",
      "layout": "default"
    },
    component: Component12
  },
  {
    path: "/reports",
    componentName: "IndexPage",
    key: "Report.Index",
    section: "report",
    container: "report",
    group: "container",
    template: "default",
    isIndex: true,
    config: {
      "title": "Index",
      "layout": "default"
    },
    component: Component13
  },
  {
    path: "/reports/mileage-control",
    componentName: "MileageControlPage",
    key: "Report.MileageControl",
    section: "report",
    container: "report",
    group: "container",
    template: "default",
    isIndex: false,
    config: {
      "title": "MileageControl",
      "layout": "default"
    },
    component: Component14
  },
  {
    path: "/request/request",
    componentName: "RequestPage",
    key: "Request.Request",
    section: "request",
    container: "request",
    group: "container",
    template: "default",
    isIndex: false,
    config: {
      "title": "Request",
      "layout": "default"
    },
    component: Component15
  },
  {
    path: "/setting/department",
    componentName: "DepartmentPage",
    key: "Setting.Department",
    section: "setting",
    container: "department",
    group: "container",
    template: "default",
    isIndex: false,
    config: {
      "title": "Department",
      "layout": "default"
    },
    component: Component16
  },
  {
    path: "/settings/erp-exchange",
    componentName: "IndexPage",
    key: "Setting.Index",
    section: "setting",
    container: "erpexchange",
    group: "container",
    template: "default",
    isIndex: true,
    config: {
      "title": "Index",
      "layout": "default"
    },
    component: Component17
  },
  {
    path: "/setting",
    componentName: "IndexPage",
    key: "Setting.Index",
    section: "setting",
    container: "list",
    group: "container",
    template: "default",
    isIndex: true,
    config: {
      "title": "Index",
      "layout": "default"
    },
    component: Component18
  },
  {
    path: "/settings/portal-settings",
    componentName: "IndexPage",
    key: "Setting.Index",
    section: "setting",
    container: "portal-settings",
    group: "container",
    template: "default",
    isIndex: true,
    config: {
      "title": "Index",
      "layout": "default"
    },
    component: Component19
  },
  {
    path: "/setting/profile",
    componentName: "ProfilePage",
    key: "Setting.Profile",
    section: "setting",
    container: "profile",
    group: "container",
    template: "default",
    isIndex: false,
    config: {
      "title": "Profile",
      "layout": "default"
    },
    component: Component20
  },
  {
    path: "/settings/system-events",
    componentName: "IndexPage",
    key: "Setting.Index",
    section: "setting",
    container: "system-events",
    group: "container",
    template: "default",
    isIndex: true,
    config: {
      "title": "Index",
      "layout": "default"
    },
    component: Component21
  },
  {
    path: "/users",
    componentName: "UserPage",
    key: "Setting.User",
    section: "setting",
    container: "user",
    group: "container",
    template: "default",
    isIndex: false,
    config: {
      "title": "User",
      "layout": "default"
    },
    component: Component22
  },
  {
    path: "/setting/user-profile",
    componentName: "UserProfilePage",
    key: "Setting.UserProfile",
    section: "setting",
    container: "user",
    group: "container",
    template: "default",
    isIndex: false,
    config: {
      "title": "UserProfile",
      "layout": "default"
    },
    component: Component23
  },
  {
    path: "/shifts",
    componentName: "ShiftPage",
    key: "Shift.Shift",
    section: "shift",
    container: "shift",
    group: "container",
    template: "default",
    isIndex: false,
    config: {
      "title": "Shift",
      "layout": "default"
    },
    component: Component24
  },
  {
    path: "/transport/drivers",
    componentName: "DriverPage",
    key: "Transport.Driver",
    section: "transport",
    container: "driver",
    group: "container",
    template: "default",
    isIndex: false,
    config: {
      "title": "Driver",
      "layout": "default"
    },
    component: Component25
  },
  {
    path: "/transport/vehicle",
    componentName: "VehiclePage",
    key: "Transport.Vehicle",
    section: "transport",
    container: "vehicle",
    group: "container",
    template: "default",
    isIndex: false,
    config: {
      "title": "Vehicle",
      "layout": "default"
    },
    component: Component26
  },
  {
    path: "/requests",
    componentName: "UniversalResourcePage",
    key: "Request.Request",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Заявки - Список",
      "layout": "default",
      "resourceKey": "Request.Request"
    },
    component: Component27
  },
  {
    path: "/requests/create",
    componentName: "UniversalResourcePage",
    key: "Request.Request.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Заявки - Створити",
      "layout": "default",
      "resourceKey": "Request.Request"
    },
    component: Component28
  },
  {
    path: "/requests/:id",
    componentName: "UniversalResourcePage",
    key: "Request.Request.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Заявки - Перегляд",
      "layout": "default",
      "resourceKey": "Request.Request"
    },
    component: Component29
  },
  {
    path: "/requests/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Request.Request.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Заявки - Редагувати",
      "layout": "default",
      "resourceKey": "Request.Request"
    },
    component: Component30
  },
  {
    path: "/settings/erp-exchange",
    componentName: "UniversalResourcePage",
    key: "Setting.ErpExchange",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Журнал обміну ERP - Список",
      "layout": "default",
      "resourceKey": "Setting.ErpExchange"
    },
    component: Component31
  },
  {
    path: "/settings/erp-exchange/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ErpExchange.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Журнал обміну ERP - Створити",
      "layout": "default",
      "resourceKey": "Setting.ErpExchange"
    },
    component: Component32
  },
  {
    path: "/settings/erp-exchange/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ErpExchange.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Журнал обміну ERP - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ErpExchange"
    },
    component: Component33
  },
  {
    path: "/settings/erp-exchange/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ErpExchange.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Журнал обміну ERP - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ErpExchange"
    },
    component: Component34
  },
  {
    path: "/settings/cancellation-reasons",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCancellationReason",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Причини скасування - Список",
      "layout": "default",
      "resourceKey": "Setting.ListCancellationReason"
    },
    component: Component35
  },
  {
    path: "/settings/cancellation-reasons/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCancellationReason.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Причини скасування - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListCancellationReason"
    },
    component: Component36
  },
  {
    path: "/settings/cancellation-reasons/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCancellationReason.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Причини скасування - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListCancellationReason"
    },
    component: Component37
  },
  {
    path: "/settings/cancellation-reasons/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCancellationReason.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Причини скасування - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListCancellationReason"
    },
    component: Component38
  },
  {
    path: "/settings/cargos",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCargo",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Вантажі - Список",
      "layout": "default",
      "resourceKey": "Setting.ListCargo"
    },
    component: Component39
  },
  {
    path: "/settings/cargos/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCargo.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Вантажі - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListCargo"
    },
    component: Component40
  },
  {
    path: "/settings/cargos/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCargo.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Вантажі - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListCargo"
    },
    component: Component41
  },
  {
    path: "/settings/cargos/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCargo.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Вантажі - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListCargo"
    },
    component: Component42
  },
  {
    path: "/settings/carriers",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCarrier",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Перевізники - Список",
      "layout": "default",
      "resourceKey": "Setting.ListCarrier"
    },
    component: Component43
  },
  {
    path: "/settings/carriers/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCarrier.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Перевізники - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListCarrier"
    },
    component: Component44
  },
  {
    path: "/settings/carriers/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCarrier.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Перевізники - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListCarrier"
    },
    component: Component45
  },
  {
    path: "/settings/carriers/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCarrier.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Перевізники - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListCarrier"
    },
    component: Component46
  },
  {
    path: "/settings/clusters",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCluster",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Кластери - Список",
      "layout": "default",
      "resourceKey": "Setting.ListCluster"
    },
    component: Component47
  },
  {
    path: "/settings/clusters/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCluster.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Кластери - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListCluster"
    },
    component: Component48
  },
  {
    path: "/settings/clusters/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCluster.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Кластери - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListCluster"
    },
    component: Component49
  },
  {
    path: "/settings/clusters/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCluster.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Кластери - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListCluster"
    },
    component: Component50
  },
  {
    path: "/settings/cluster-responsibles",
    componentName: "UniversalResourcePage",
    key: "Setting.ListClusterResponsible",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Відповідальні за кластер - Список",
      "layout": "default",
      "resourceKey": "Setting.ListClusterResponsible"
    },
    component: Component51
  },
  {
    path: "/settings/cluster-responsibles/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListClusterResponsible.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Відповідальні за кластер - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListClusterResponsible"
    },
    component: Component52
  },
  {
    path: "/settings/cluster-responsibles/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListClusterResponsible.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Відповідальні за кластер - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListClusterResponsible"
    },
    component: Component53
  },
  {
    path: "/settings/cluster-responsibles/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListClusterResponsible.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Відповідальні за кластер - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListClusterResponsible"
    },
    component: Component54
  },
  {
    path: "/settings/construction-objects",
    componentName: "UniversalResourcePage",
    key: "Setting.ListConstructionObject",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Об - Список",
      "layout": "default",
      "resourceKey": "Setting.ListConstructionObject"
    },
    component: Component55
  },
  {
    path: "/settings/construction-objects/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListConstructionObject.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Об - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListConstructionObject"
    },
    component: Component56
  },
  {
    path: "/settings/construction-objects/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListConstructionObject.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Об - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListConstructionObject"
    },
    component: Component57
  },
  {
    path: "/settings/construction-objects/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListConstructionObject.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Об - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListConstructionObject"
    },
    component: Component58
  },
  {
    path: "/settings/loading-points",
    componentName: "UniversalResourcePage",
    key: "Setting.ListLoadingPoint",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Пункти навантаження/розвантаження - Список",
      "layout": "default",
      "resourceKey": "Setting.ListLoadingPoint"
    },
    component: Component59
  },
  {
    path: "/settings/loading-points/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListLoadingPoint.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Пункти навантаження/розвантаження - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListLoadingPoint"
    },
    component: Component60
  },
  {
    path: "/settings/loading-points/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListLoadingPoint.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Пункти навантаження/розвантаження - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListLoadingPoint"
    },
    component: Component61
  },
  {
    path: "/settings/loading-points/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListLoadingPoint.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Пункти навантаження/розвантаження - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListLoadingPoint"
    },
    component: Component62
  },
  {
    path: "/settings/object-types",
    componentName: "UniversalResourcePage",
    key: "Setting.ListObjectType",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Типи об - Список",
      "layout": "default",
      "resourceKey": "Setting.ListObjectType"
    },
    component: Component63
  },
  {
    path: "/settings/object-types/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListObjectType.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Типи об - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListObjectType"
    },
    component: Component64
  },
  {
    path: "/settings/object-types/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListObjectType.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Типи об - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListObjectType"
    },
    component: Component65
  },
  {
    path: "/settings/object-types/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListObjectType.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Типи об - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListObjectType"
    },
    component: Component66
  },
  {
    path: "/settings/organization-units",
    componentName: "UniversalResourcePage",
    key: "Setting.ListOrganizationUnit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Підрозділи - Список",
      "layout": "default",
      "resourceKey": "Setting.ListOrganizationUnit"
    },
    component: Component67
  },
  {
    path: "/settings/organization-units/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListOrganizationUnit.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Підрозділи - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListOrganizationUnit"
    },
    component: Component68
  },
  {
    path: "/settings/organization-units/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListOrganizationUnit.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Підрозділи - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListOrganizationUnit"
    },
    component: Component69
  },
  {
    path: "/settings/organization-units/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListOrganizationUnit.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Підрозділи - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListOrganizationUnit"
    },
    component: Component70
  },
  {
    path: "/settings/positions",
    componentName: "UniversalResourcePage",
    key: "Setting.ListPosition",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Посади - Список",
      "layout": "default",
      "resourceKey": "Setting.ListPosition"
    },
    component: Component71
  },
  {
    path: "/settings/positions/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListPosition.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Посади - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListPosition"
    },
    component: Component72
  },
  {
    path: "/settings/positions/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListPosition.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Посади - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListPosition"
    },
    component: Component73
  },
  {
    path: "/settings/positions/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListPosition.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Посади - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListPosition"
    },
    component: Component74
  },
  {
    path: "/settings/production-objects",
    componentName: "UniversalResourcePage",
    key: "Setting.ListProductionObject",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Об - Список",
      "layout": "default",
      "resourceKey": "Setting.ListProductionObject"
    },
    component: Component75
  },
  {
    path: "/settings/production-objects/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListProductionObject.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Об - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListProductionObject"
    },
    component: Component76
  },
  {
    path: "/settings/production-objects/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListProductionObject.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Об - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListProductionObject"
    },
    component: Component77
  },
  {
    path: "/settings/production-objects/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListProductionObject.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Об - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListProductionObject"
    },
    component: Component78
  },
  {
    path: "/settings/regions",
    componentName: "UniversalResourcePage",
    key: "Setting.ListRegion",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Регіони - Список",
      "layout": "default",
      "resourceKey": "Setting.ListRegion"
    },
    component: Component79
  },
  {
    path: "/settings/regions/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListRegion.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Регіони - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListRegion"
    },
    component: Component80
  },
  {
    path: "/settings/regions/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListRegion.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Регіони - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListRegion"
    },
    component: Component81
  },
  {
    path: "/settings/regions/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListRegion.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Регіони - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListRegion"
    },
    component: Component82
  },
  {
    path: "/settings/tech-operations",
    componentName: "UniversalResourcePage",
    key: "Setting.ListTechOperation",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Технічні операції - Список",
      "layout": "default",
      "resourceKey": "Setting.ListTechOperation"
    },
    component: Component83
  },
  {
    path: "/settings/tech-operations/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListTechOperation.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Технічні операції - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListTechOperation"
    },
    component: Component84
  },
  {
    path: "/settings/tech-operations/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListTechOperation.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Технічні операції - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListTechOperation"
    },
    component: Component85
  },
  {
    path: "/settings/tech-operations/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListTechOperation.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Технічні операції - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListTechOperation"
    },
    component: Component86
  },
  {
    path: "/settings/vehicle-kinds",
    componentName: "UniversalResourcePage",
    key: "Setting.ListVehicleKind",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Види транспортних засобів - Список",
      "layout": "default",
      "resourceKey": "Setting.ListVehicleKind"
    },
    component: Component87
  },
  {
    path: "/settings/vehicle-kinds/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListVehicleKind.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Види транспортних засобів - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListVehicleKind"
    },
    component: Component88
  },
  {
    path: "/settings/vehicle-kinds/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListVehicleKind.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Види транспортних засобів - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListVehicleKind"
    },
    component: Component89
  },
  {
    path: "/settings/vehicle-kinds/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListVehicleKind.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Види транспортних засобів - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListVehicleKind"
    },
    component: Component90
  },
  {
    path: "/settings/vehicle-types",
    componentName: "UniversalResourcePage",
    key: "Setting.ListVehicleType",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Типи транспортних засобів - Список",
      "layout": "default",
      "resourceKey": "Setting.ListVehicleType"
    },
    component: Component91
  },
  {
    path: "/settings/vehicle-types/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListVehicleType.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Типи транспортних засобів - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListVehicleType"
    },
    component: Component92
  },
  {
    path: "/settings/vehicle-types/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListVehicleType.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Типи транспортних засобів - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListVehicleType"
    },
    component: Component93
  },
  {
    path: "/settings/vehicle-types/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListVehicleType.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Типи транспортних засобів - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListVehicleType"
    },
    component: Component94
  },
  {
    path: "/settings/manual-tokens",
    componentName: "UniversalResourcePage",
    key: "Setting.ManualToken",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Ручні токени - Список",
      "layout": "default",
      "resourceKey": "Setting.ManualToken"
    },
    component: Component95
  },
  {
    path: "/settings/manual-tokens/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ManualToken.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Ручні токени - Створити",
      "layout": "default",
      "resourceKey": "Setting.ManualToken"
    },
    component: Component96
  },
  {
    path: "/settings/manual-tokens/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ManualToken.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Ручні токени - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ManualToken"
    },
    component: Component97
  },
  {
    path: "/settings/manual-tokens/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ManualToken.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Ручні токени - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ManualToken"
    },
    component: Component98
  },
  {
    path: "/settings/system-events",
    componentName: "UniversalResourcePage",
    key: "Setting.SystemEvent",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Системні події - Список",
      "layout": "default",
      "resourceKey": "Setting.SystemEvent"
    },
    component: Component99
  },
  {
    path: "/settings/system-events/create",
    componentName: "UniversalResourcePage",
    key: "Setting.SystemEvent.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Системні події - Створити",
      "layout": "default",
      "resourceKey": "Setting.SystemEvent"
    },
    component: Component100
  },
  {
    path: "/settings/system-events/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.SystemEvent.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Системні події - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.SystemEvent"
    },
    component: Component101
  },
  {
    path: "/settings/system-events/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.SystemEvent.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Системні події - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.SystemEvent"
    },
    component: Component102
  },
  {
    path: "/shifts",
    componentName: "UniversalResourcePage",
    key: "Shift.Shift",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Зміни - Список",
      "layout": "default",
      "resourceKey": "Shift.Shift"
    },
    component: Component103
  },
  {
    path: "/shifts/create",
    componentName: "UniversalResourcePage",
    key: "Shift.Shift.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Зміни - Створити",
      "layout": "default",
      "resourceKey": "Shift.Shift"
    },
    component: Component104
  },
  {
    path: "/shifts/:id",
    componentName: "UniversalResourcePage",
    key: "Shift.Shift.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Зміни - Перегляд",
      "layout": "default",
      "resourceKey": "Shift.Shift"
    },
    component: Component105
  },
  {
    path: "/shifts/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Shift.Shift.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Зміни - Редагувати",
      "layout": "default",
      "resourceKey": "Shift.Shift"
    },
    component: Component106
  },
  {
    path: "/transport/typical-routes",
    componentName: "UniversalResourcePage",
    key: "Transport.TypicalRoute",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Типові маршрути - Список",
      "layout": "default",
      "resourceKey": "Transport.TypicalRoute"
    },
    component: Component107
  },
  {
    path: "/transport/typical-routes/create",
    componentName: "UniversalResourcePage",
    key: "Transport.TypicalRoute.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Типові маршрути - Створити",
      "layout": "default",
      "resourceKey": "Transport.TypicalRoute"
    },
    component: Component108
  },
  {
    path: "/transport/typical-routes/:id",
    componentName: "UniversalResourcePage",
    key: "Transport.TypicalRoute.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Типові маршрути - Перегляд",
      "layout": "default",
      "resourceKey": "Transport.TypicalRoute"
    },
    component: Component109
  },
  {
    path: "/transport/typical-routes/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Transport.TypicalRoute.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Типові маршрути - Редагувати",
      "layout": "default",
      "resourceKey": "Transport.TypicalRoute"
    },
    component: Component110
  },
  {
    path: "/transport/vehicles",
    componentName: "UniversalResourcePage",
    key: "Transport.Vehicle",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Транспортні засоби - Список",
      "layout": "default",
      "resourceKey": "Transport.Vehicle"
    },
    component: Component111
  },
  {
    path: "/transport/vehicles/create",
    componentName: "UniversalResourcePage",
    key: "Transport.Vehicle.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Транспортні засоби - Створити",
      "layout": "default",
      "resourceKey": "Transport.Vehicle"
    },
    component: Component112
  },
  {
    path: "/transport/vehicles/:id",
    componentName: "UniversalResourcePage",
    key: "Transport.Vehicle.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Транспортні засоби - Перегляд",
      "layout": "default",
      "resourceKey": "Transport.Vehicle"
    },
    component: Component113
  },
  {
    path: "/transport/vehicles/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Transport.Vehicle.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Транспортні засоби - Редагувати",
      "layout": "default",
      "resourceKey": "Transport.Vehicle"
    },
    component: Component114
  }
]

export default generatedRoutes
